export default __webpack_public_path__ + "static/media/24-face-vomiting_1f92e.c593ba31.png";